export default "__VITE_ASSET__C3q6Tzhq__"